import { createLazyRouteComponent } from 'helpers/createLazyRouteComponent'
import { ROUTE } from 'constants/index'

const Profile = (store) => ({
  path: ROUTE.PROFILE,
  component: createLazyRouteComponent({
    store,
    reducerKey: 'profile',
    loadReducer: () => import('./ProfileState'),
    loadComponent: () => import('./ProfileContainer'),
  })
})

export default Profile
